import script from "./chose-order.vue?vue&type=script&setup=true&lang=js"
export * from "./chose-order.vue?vue&type=script&setup=true&lang=js"

import "./chose-order.vue?vue&type=style&index=0&id=cde08d6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cde08d6c"]])

export default __exports__